"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
/*
	intro : unify mult async process
	Author : chenchao
	Date : 2019-06-18
*/


var _reactPureCheck = require("react-pure-check");

var _log = require("./log");

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var MultAsyncFun = function () {
  function MultAsyncFun() {
    var processNum = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var callback = arguments[1];

    _classCallCheck(this, MultAsyncFun);

    this.processNum = processNum;
    this.tempNum = 0;
    this.callback = callback;
    this.result = {};

    if ((0, _reactPureCheck.Types)(MultAsyncFun.unique) !== "undefined") {
      return MultAsyncFun.unique;
    }

    MultAsyncFun.unique = this;
  } // wether register a given key


  _createClass(MultAsyncFun, [{
    key: "authKey",
    value: function authKey() {
      var keyName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      if ((0, _reactPureCheck.Types)(keyName) !== "string") {
        (0, _log.errorBreak)("you should offer a %s for keyName", "string");
        return false;
      }

      ;
      return true;
    } // registerProcess

  }, {
    key: "registerProcess",
    value: function registerProcess() {
      var keyName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      if (!this.authKey(keyName)) return false;
      this.result[keyName] = data; // has got the key number of your process

      if (++this.tempNum * 1 === this.processNum * 1) {
        this.callback(Object.assign({}, this.result));
        this.tempNum = 0;
      }
    }
  }]);

  return MultAsyncFun;
}();

; // @processNum - your async process numbers
// @callback

var MultAsync = function MultAsync(processNum, callback) {
  if ((0, _reactPureCheck.Types)(processNum) !== "number" || processNum * 1 === 0 || (0, _reactPureCheck.Types)(callback) !== "function") {
    (0, _log.errorBreak)("you should offer a %s for processNum , a %s for callback", "string", "function");
    return {
      registerProcess: function registerProcess() {}
    };
  }

  return new MultAsyncFun(processNum, callback);
};

exports.default = MultAsync;